import { useEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import commonUtil from "../../common/commonUtil";
import Const from "../../const/Const";
import { Label } from "../atoms/label";
import { OptionPullDown } from "../atoms/optionPullDown";
import './../../resources_membership_hotel/css/hotel/reserve.css';
import { ModalOptionForm } from "./modalOptionForm";
import { PullDownOptionForm } from "./pullDownOptionForm";

const ConditionChangeArea = (props) => {
    const {
        room,
        adultNum,
        childNum,
        setRoom,
        setAdultNum,
        setChildNum,
        style,
        isMobilePhone,
        onClickOpenCheckListWindow,
        errFlgList,
        membershipReserveComf,
        kaiinkenInfo,
        dateList,
        setDateList,
        generalFlg } = props;

    const [roomNumber, setRoomNumber] = useState("1");
    const [dispAdultNum, setDispAdultNum] = useState("2");
    const [dispChildNum, setDispChildNum] = useState("0");
    const store = useStore();

    // 初期値セット
    useEffect(() => {
        const roomNum = String(membershipReserveComf.roomCnt);
        setRoomNumber(roomNum);
        if(1 < Number(roomNum)) {
            // 大人+小人の合計->大人の合計の順で比較し、一番大きいものを抽出
            let allSum = 0;
            let adultSum = 0;
            let childSum = 0;
            membershipReserveComf.roomList.forEach((r)=> {
                const currentAdultSum = r.menCnt + r.womenCnt;
                const currentChildSum = r.childCnt;
                const currentAllSum = currentAdultSum + currentChildSum;
                // 合計が大きい方を格納する
                if(allSum < currentAllSum){
                    allSum = currentAllSum;
                    adultSum = currentAdultSum;
                    childSum = currentChildSum;
                }
                // 合計が同じなら大人の合計で大きい方を格納する
                else if(allSum === currentAllSum){
                    if(adultSum < currentAdultSum){
                        allSum = currentAllSum;
                        adultSum = currentAdultSum;
                        childSum = currentChildSum;
                    }
                }
            });
            setAdultNum(commonUtil.getPeopleNumList(1, Const.MAX_ROOM_CAPACITY, adultSum));
            setChildNum(commonUtil.getPeopleNumList(0, Const.MAX_ROOM_CAPACITY - 1, childSum));
            setDispAdultNum(String(adultSum));
            setDispChildNum(String(childSum));
        } else {
            // 人数設定処理
            const humanCountObj = membershipReserveComf.roomList.reduce((acc, current) => {
              const adultCnt = acc.adultCnt + (current.menCnt ? Number(current.menCnt) : 0) + (current.womenCnt ? Number(current.womenCnt) : 0);
              return {
                adultCnt: adultCnt,
                childCnt: acc.childCnt + (current.childCnt ? Number(current.childCnt) : 0)
              };
            }, { adultCnt: 0, childCnt: 0 })
            const adultList = commonUtil.getPeopleNumList(1, 5, humanCountObj.adultCnt)
            const childList = commonUtil.getPeopleNumList(0, 4, humanCountObj.childCnt)
            setAdultNum(adultList)
            setChildNum(childList)
            setDispAdultNum(adultList.find(n => n.selected).id);
            setDispChildNum(childList.find(n => n.selected).id);
        }
    }, [])

    // チェックイン表示処理
    const getDateToString = () => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const checkInDate = new Date(membershipReserveComf.checkInDate);
        const y = checkInDate.getFullYear();
        const m = checkInDate.getMonth() + 1;
        const d = checkInDate.getDate();

        return `${y}年${m}月${d}日(${youbi[checkInDate.getDay()]})`;
    }

    // 詳細条件表示
    const getDetailCriteria = () => {
        let dispText = store.getState().dispDetailCondition ? store.getState().dispDetailCondition : "選択なし";
        return dispText;
    }

    // 選択した組数をstoreに保存
    const onChangeRoom = (e) => {
        setRoomNumber(e.target.value);

        room.forEach((data) => {
            if (data.id === e.target.value) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setRoom(room);
    };

    // 選択した組数をstoreに保存
    const onChangeAdultNum = (e) => {
        setDispAdultNum(e.target.value);
        const selected = e.target.value;
        adultNum.forEach((data) => {
            if (data.id === selected) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setAdultNum(adultNum);
    };

    // 選択した組数をstoreに保存
    const onChangeChildNum = (e) => {
        setDispChildNum(e.target.value);
        const selected = e.target.value;
        childNum.forEach((data) => {
            if (data.id === selected) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setChildNum(childNum);
    };

    // 選択した組数をstoreに保存
    const onChangeCheckOut = (e) => {
        dateList.forEach((data) => {
            if (String(data.id) === e.target.value) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setDateList(dateList);
    };

    return (
        <>
            <div style={style.container}>
                <div className={isMobilePhone ? "wrapMobile" : "wrap"} >
                    <Label label="チェックイン" className="modalLabel" />
                    <Label label={getDateToString()} />
                </div>
                <PullDownOptionForm
                    id="roomNum"
                    divClass={isMobilePhone ? "wrapMobile" : "wrap"}
                    labelClassName={"modalLabel"}
                    title={"チェックアウト"}
                    selectClass={"pullDownOptionStyle"}
                    data={dateList}
                    onChange={onChangeCheckOut}
                />
                <div className={isMobilePhone ? "wrapMobile" : "wrap"} >
                    <Label label="ホテル" className="modalLabel" />
                    <Label label={membershipReserveComf.shisetsuName} />
                </div>
                <div className={isMobilePhone ? "wrapMobile" : "wrap"}>
                    <Label className={"membershipModalLabel"} label={isMobilePhone ? "1室あたり利用人数\n（小学生未満の人数は入力不要）" : "1室あたり利用人数（小学生未満の人数は入力不要）"} />
                    <div className={isMobilePhone ? "" : "humanInput"}>
                        <div className={isMobilePhone ? "humanPullDownSp" : "humanPullDown"}>
                            <Label className={"modalLabel"} label="大人" />
                            <OptionPullDown
                                data={adultNum}
                                selectClass={errFlgList.errPeopleNum || errFlgList.errAdultNum ? "humanPullDownOptionStyleErr" : "humanPullDownOptionStyle"}
                                onChange={onChangeAdultNum}
                                value={dispAdultNum}
                                id="adultNum"
                            />
                        </div>
                        <div className={isMobilePhone ? "humanPullDownSp" : "humanPullDown"}>
                            <Label className={"modalLabel"} label="小学生" />
                            <OptionPullDown
                                data={childNum}
                                selectClass={errFlgList.errPeopleNum ? "humanPullDownOptionStyleErr" : "humanPullDownOptionStyle"}
                                onChange={onChangeChildNum}
                                value={dispChildNum}
                                id="childNum"
                            />
                        </div>
                    </div>
                </div>
                <PullDownOptionForm
                    id="roomNum"
                    divClass={isMobilePhone ? "wrapMobile" : "wrap"}
                    labelClassName={"modalLabel"}
                    title={"室数"}
                    selectClass={"pullDownOptionStyle"}
                    data={room}
                    state={roomNumber}
                    onChange={onChangeRoom}
                />
                <div className={isMobilePhone ? "wrapMobile" : "wrap"} >
                    <Label label="会員権選択" className="modalLabel" />
                    <Label label={generalFlg ? `一般` : kaiinkenInfo.kaiinkenNo} />
                </div>
                {!generalFlg &&
                    <ModalOptionForm
                        id={"detailCriteria"}
                        divClass={isMobilePhone ? "wrapMobile" : "detailCriteriaWrap"}
                        title={"詳細条件"}
                        onClick={onClickOpenCheckListWindow}
                        text={getDetailCriteria()} />
                }
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        checkOut: state.checkOut,
        room: state.room,
        detailCondition: state.detailCondition,
        startTime: state.startTime,
        kaiinken: state.kaiinken,
        adultNum: state.adultNum,
        childNum: state.childNum,
        membershipReserveComf: state.membershipReserveComf
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setAdultNum: (item) => {
            dispatch({ type: "ADULT_NUM", payload: { adultNum: item } })
        },
        setChildNum: (item) => {
            dispatch({ type: "CHILD_NUM", payload: { childNum: item } })
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConditionChangeArea);